
import { ref, computed } from 'vue';
export default {
    setup(){
        const email = ref('');
        const checkEmail = computed(() => {
            return email.value.length > 0 && email.value.includes('@') ? 'border: 2px solid green' : 'border: 2px solid red';
        });
        return {
            email,
            checkEmail
        }
    }
}
